<div wms-split-panel split="vertical" showdividers="true" class="split-panel vertical">
  <div wms-split-pane limit="210" class="resources-pane split-pane" [ngClass]="{'hide-resource-panel': hideResources}">
    <div class="wm-workspace-left-panel">
      <!-- File Explorer -->
      <div class="wm-workspace-left-panel-content resource-category">
        <div class="full-height">
          <div class="panel-label">
            <span>{{locale.LABEL_FILES_TREE_RESOURCES}}</span>
            <span class="float-right category-actions" *wmsFeature="preferences.project?.import.resource">
                <i class="wms wms-refresh" (click)="refreshResources(selectedNode.path, null)"
                   [attr.title]="locale.LABEL_REFRESH_CONSOLE"></i>
                <i class="wms wms-add" (click)="importResource($event)"
                   [attr.title]="locale.LABEL_IMPORT_RESOURCE"></i>
            </span>
          </div>
          <div class="wm-tree-container wm-file-workspace-tree" *ngIf="projectResourcesTree.length">
            <wms-tree name="wm-projectresources-tree" [data]="projectResourcesTree" *wmsFeature="preferences.project?.resources.files.project"
                      (nodeClick)="handleResourceNodeClick($event)"
                      [hasSearch]="true" class="list-type-tree" [expandByDefault]="true" [selectedNode]="selectedNode">
            </wms-tree>
          </div>
          <wms-spinner *ngIf="!projectResourcesTree.length"></wms-spinner>
        </div>
      </div>
    </div>
  </div>
  <div class="split-pane-divider" data-index="1"><span class="split-pane-resizer"></span>
    <div class="wm-split-panel-collapsible horizontal" [hidden]="true">
      <button type="button" class="expand-bottom"><i class="wms wms-arrow-drop-down"></i></button>
      <button type="button" class="expand-top"><i class="wms wms-arrow-drop-up"></i></button>
    </div>
  </div>
  <div wms-split-pane limit="600" class="file-container-pane split-pane">
    <div class="wm-file-container">
      <div class="wm-resource-container wm-workspace">
        <div class="workspace-header file-workspace-header" *ngIf="fileWorkspaceService.activeResource.type">
          <div class="wm-actions-left left-action-bar">
            <ul class="tabs btn-group">
              <li class="title" [attr.title]="fileWorkspaceService.activeResource.path">
               <span> <span>{{fileWorkspaceService.project.name + (teamProjectObj.teamProjectObject.branchType === 'BRANCH' ? ' ('+fileWorkspaceService.project.vcsBranch+')' : '') + ' >'}}</span> {{displayPath}}</span>
              </li>
            </ul>
          </div>
          <div class="wm-actions-center" *ngIf="!preferences?.project.pages?.edit || fileWorkspaceService.editorOptions.readOnly">
            <span [attr.title]="locale.LABEL_SCHEMA_READONLY_MODE" class="readonly-schema">
              <span>{{ locale.LABEL_SCHEMA_READONLY_MODE}}</span>
            </span>
          </div>
        </div>
        <div class="workspace-content">
          <div class="ftux-screen" *ngIf="!fileWorkspaceService.activeResource.name">
            <div class="ftux-screen-container ftux-workspace">
              <div class="screen-container">
                <div class="img-container">
                  <img [src]="('styles/images/ftux/fileexplorer.svg' | versionManager)" alt=""/>
                </div>
                <h3 class="title">{{locale.LABEL_FILE_EXPLORER}}</h3>
                <h5>
                  <p>{{locale.LABEL_IMPORT_RESOURCE_EXISTING_FILE_MESSAGE}}</p>
                  <p>{{locale.LABEL_IMPORT_NEW_RESOURCE_MESSAGE}}</p>
                </h5>
                <button name="ci-datasource-data-model" class="btn button-primary" (click)="importResource($event)">
                  <i class="wm-icon wms wms-plus"></i>{{locale.LABEL_IMPORT_RESOURCE}}
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="fileWorkspaceService.activeResource.type === 'IMAGE'" class="wm-resource-image-container">
            <div class="wm-resource-image-canvas">
              <img [src]="fileWorkspaceService.activeResource.absPath">
            </div>
          </div>
          <div *ngIf="fileWorkspaceService.activeResource.type === 'TEXT'" class="wm-resource-text-container">
            <div class="wm-code-editor-container" [ngStyle]="{display: fileWorkspaceService.editorOptions.language === 'markdown' ? 'flex' : 'block'}">
              <div [ngStyle]="{
                  width: fileWorkspaceService.editorOptions.language === 'markdown' ? '50%' : '100%',
                  height: '100%',
                  borderRight: fileWorkspaceService.editorOptions.language === 'markdown' ? '1px solid #ddd' : 'none'
                }">
                <wms-editor [options]="fileWorkspaceService.editorOptions" (onChange)="updateEditorOptions($event.options)"
                  (onSave)="fileWorkspaceService.save(fileWorkspaceService.activeResource.path)"></wms-editor>
              </div>
              <div class="markdown-viewer" *ngIf="fileWorkspaceService.editorOptions.language === 'markdown'">
                <div id="markdown-preview"></div>
              </div>
            </div>
          </div>
          <div *ngIf="fileWorkspaceService.activeResource.type === 'CANNOT_DISPLAY' ||fileWorkspaceService.activeResource.type === 'FOLDER'" class="wm-resource-image-container">
            <div class="wm-resource-file-canvas">
              <div class="wms" [ngClass]="{'wms-folder-open':fileWorkspaceService.activeResource.type === 'FOLDER' , 'wms-file-text':fileWorkspaceService.activeResource.type === 'CANNOT_DISPLAY'}"></div>
              <h4>{{locale.PREVIEW_NOT_AVAILABLE}}</h4>
              <p>{{fileWorkspaceService.activeResource.type === 'FOLDER' ? locale.FOLDER_NAME : locale.FILE_NAME}} : {{fileWorkspaceService.activeResource.name}}</p>
              <a (click)="navigate(fileWorkspaceService.activeResource.name)" *wmsFeature="showPrefabInfoLink && fileWorkspaceService.activeResource?.relativePath?.indexOf('prefabs/')!= -1" class="prefab-info-link">{{locale.MESSAGE_PREFAB_INFO.replace('${0}', fileWorkspaceService.activeResource.name)}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
<wms-dialog id="deleteResourceModal" customClasses="delete-resource-dialog">
  <wms-dialog-header (onClose)="closeDialogWithId('deleteResourceModal')" title="Delete Resource" customClass="app-dialog-header modal-header"></wms-dialog-header>
  <wms-dialog-body customClass="app-dialog-body app-dialog-message modal-body">Are you sure you want to delete {{fileWorkspaceService.activeResource.name}}?</wms-dialog-body>
  <wms-dialog-footer customClass="app-dialog-footer modal-footer">
    <button class="cancel-action btn app-button btn-secondary ng-isolate-scope" (click)="closeDialogWithId('deleteResourceModal')">cancel</button>
    <button class="btn-primary ok-action btn app-button ng-isolate-scope" (click)="remove()">ok</button>
  </wms-dialog-footer>
</wms-dialog>
<!---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
<wms-dialog id="uploadGenericResourcesDialog" customClasses="upload-resource-container-dialog medium wm-studio-dialog">
  <wms-dialog-header (onClose)="closeDialogWithId('uploadGenericResourcesDialog')" title={{locale[dialogTitleKey]}} helpTitle={{locale[dialogTitleKey]}} helpLink={{helpLink.externalLinks.IMPORT_IMAGE}} customClass="app-dialog-header modal-header"></wms-dialog-header>
  <wms-dialog-body>
    <form class="full-height" name="genericResourceUploadForm" enctype="multipart/form-data">
      <div class="row app-row full-height clearfix">
        <div class="left-panel resources-tree col-xs-3 full-height">
          <ul>
            <li *ngFor="let resource of resources.slice(0, 9); index as i" [attr.name]="'wm-import-' + resource.name" (click)="!disableInactiveResources && changeActiveResource(resource)" [ngClass]="{'active': resource.isActive, 'disabled': !resource.isActive && disableInactiveResources, 'enabled': !disableInactiveResources}">
              <span class="resource-label">{{locale[resource.displayKey]}}</span>
            </li>
          </ul>
        </div>
        <div class="col-xs-9 full-height">
          <div class="toolbar row">
            <div>
              <button class="add-folder-btn btn app-button btn-transparent" type="button"  *ngIf="resourceView !== 'icons'"  (click)="ctrlScope.showAddFolderOption = !ctrlScope.showAddFolderOption;" name="wm-add-folder" [attr.title]="locale['LABEL_ADD_NEW_FOLDER']">
                <i class="wm-icon wms wms-create-folder"></i>
              </button>
              <button type="button" class="delete-btn btn app-button btn-transparent" *ngIf="((!ctrlScope.showAddFolderOption && resourceView !== 'icons') || (dialogProjectResourcesTree && dialogProjectResourcesTree[0]?.children.length > 0 && resourceView === 'icons' && !showUploadFont))" (click)="dialogDeleteIconClick()" name="wm-delete-folder" [attr.title]="locale['LABEL_DELETE_FOLDER']">
                <i class="wm-icon wms wms-delete"></i>
              </button>
              <div class="files-container" *ngIf="resourceView === 'icons' && !showUploadFont && dialogProjectResourcesTree && dialogProjectResourcesTree.length && dialogProjectResourcesTree[0].children.length > 0 ">
                <button class="btn btn-primary" (click)="showUploadFontsOn()"  >{{locale.LABEL_UPLOAD_ICON_FONT}}</button>
              </div>

              <div class="files-container"   *ngIf="resourceView !== 'icons'">
                <wms-file-upload [acceptType]="mimeType" (onClick)="handleUploadFilesClick($event); " (onChoose)="getSelectedFile($event)" [acceptMultipleFiles]="true" [disabled]="disableDialogActions"></wms-file-upload>
              </div>
              <div class="{{messageClass}} import-msg-container" *ngIf="uploadMessage.caption" [attr.title]="uploadMessage.caption">
                <i [attr.title]="uploadMessage.type + ' alert'" class="icon {{messageIconClass}}"></i>
                <span class="import-msg">{{uploadMessage.caption}}</span>
              </div>
            </div>
            <div class="float-left add-folder-controls" *ngIf="ctrlScope.showAddFolderOption">
              <label class="control-label app-label required">{{locale.LABEL_FOLDER_NAME}}</label>
              <span *ngIf="!addingFolder" class="foldername_input_container">
                <input name="new_foldername_input" #new_folder_name_input required type="text" class="form-control app-textbox foldername-input" [(ngModel)]="newFolderName" (keyup)="onKeyPress($event, newFolderName)" [ngModelOptions]="{standalone: true, updateOn: 'change'}" placeholder={{locale.LABEL_PLACEHOLDER_ENTER_FOLDER_NAME}}/>
                <i class="app-icon wms wms-done" (click)="addFolder(newFolderName)" [attr.title]="locale.LABEL_ADD_FOLDER"></i>
                <i class="app-icon wms wms-clear" (click)="onAddFolderViewClose()" [attr.title]="locale.LABEL_CANCEL"></i>
                <i class="wms wms-help" [attr.title]="locale.LABEL_ADD_FOLDER_TITLE"></i>
                <i class="loading"></i>
              </span>
              <div class="{{messageClass}} import-msg-container" *ngIf="uploadMessage.caption" [attr.title]="uploadMessage.caption">
                <i [attr.title]="uploadMessage.type + ' alert'" class="icon {{messageIconClass}}"></i>
                <span class="import-msg">{{uploadMessage.caption}}</span>
              </div>
            </div>
          </div>
          <wms-add-custom-icon-template [showUploadFont]="showUploadFont" *ngIf=" showUploadFont || (dialogProjectResourcesTree  && dialogProjectResourcesTree.length === 0 && resourceView === 'icons')||(dialogProjectResourcesTree && dialogProjectResourcesTree[0]?.children.length === 0 && resourceView === 'icons')||(!dialogProjectResourcesTree && resourceView === 'icons')"   (refreshResourceDialoge)="refreshDialogResources($event.value)"  (goBacktoResource)="goBacktoResource()" ></wms-add-custom-icon-template>
          <div [wmsResourceDropTarget]    *ngIf="!showUploadFont"  (dropView)="handleDropView($event)" (uploadDroppedFiles)="handleUploadDroppedFiles($event)" class="col-xs-8 resources-panel">
            <div class="dropbox" *ngIf="showDropView">
              <i class="wms wms-plus-circle"></i>
              <span>{{locale.LABEL_DROP_FILES}}</span>
            </div>
            <div class="resources-tree-right-panel resources-tree">
              <ng-container *ngIf="dialogProjectResourcesTree.length && !(dialogProjectResourcesTree  && dialogProjectResourcesTree.length && dialogProjectResourcesTree[0].children.length === 0 && resourceView === 'icons')">
                <wms-tree name="wm-upload-projectresources-tree" [data]="dialogProjectResourcesTree" [hasSearch]="true" (nodeClick)="handleDialogResourceNodeClick($event)" [expandByDefault]="true" [selectedNode]="dialogSelectedNode"></wms-tree>
              </ng-container>
            </div>
          </div>
          <div class="image-view-panel col-xs-4">
            <div class="image-panel" *ngIf="dialogActiveResource.name">
              <ng-container *ngIf="isImageFile(dialogActiveResource.name); else textFile">
                <div class="file-thumbnail-container">
                  <img class="app-picture" [src]="'/studio/services/projects/' + fileWorkspaceService.project.studioProjectId + '/resources/content/web/' + dialogActiveResource.path"/>
                </div>
              </ng-container>
              <ng-template #textFile>
                <ng-container *ngIf="isTextLikeFile(dialogActiveResource.name) || isDockerFile(dialogActiveResource.name); else folderIcon">
                  <div class="file-thumbnail-container">
                    <img class="app-picture" [src]="'/studio/services/projects/' + fileWorkspaceService.project.studioProjectId + '/resources/content/web/resources/images/imagelists/default-image.png'"/>
                  </div>
                </ng-container>
              </ng-template>
              <ng-template #folderIcon>
                <ng-container *ngIf="dialogActiveResource.type === 'folder'; else defaultIcon">
                  <div>
                    <i class="wms wms-folder folder-icon"></i>
                  </div>
                </ng-container>
              </ng-template>
              <ng-template #defaultIcon>
                <ng-container>
                  <div class="file-thumbnail-container">
                    <img class="app-picture" [src]="'/studio/services/projects/' + fileWorkspaceService.project.studioProjectId + '/resources/content/web/resources/images/imagelists/default-image.png'"/>
                  </div>
                </ng-container>
              </ng-template>
              <div class="file-details">
                <label>{{dialogActiveResource.name}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </wms-dialog-body>
  <wms-dialog-footer>
    <label class="app-label select-files-label float-left">{{locale.LABEL_FILE_UPLOAD_FOLDER}}</label>
    <input class="form-control folder-path" [attr.title]="folder" name="wm-selected-folder-path" [(ngModel)]="folder" disabled>
    <button class="btn app-button button-secondary" name="wm-import-resource-close" [disabled]="disableDialogActions" (click)="closeDialogWithId('uploadGenericResourcesDialog')"
            [attr.title]="locale.LABEL_CANCEL">{{locale.LABEL_CANCEL}}
    </button>
  </wms-dialog-footer>
</wms-dialog>
<!----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
<wms-dialog id="dialogDeleteResourceModal" customClasses="delete-resource-dialog modal small wm-studio-dialog">
  <wms-dialog-header (onClose)="closeDialogWithId('dialogDeleteResourceModal')" title="Delete Resource" customClass="app-dialog-header modal-header"></wms-dialog-header>
  <wms-dialog-body customClass="app-dialog-body app-dialog-message modal-body"> {{locale.MESSAGE_DELETE_RESOURCE.replace('${0}', dialogActiveResource.name)}}</wms-dialog-body>
  <wms-dialog-footer customClass="app-dialog-footer modal-footer">
    <button class="cancel-action btn app-button btn-secondary ng-isolate-scope" (click)="closeDialogWithId('dialogDeleteResourceModal')">{{locale.LABEL_CANCEL}}</button>
    <button class="btn-primary ok-action btn app-button ng-isolate-scope" (click)="deleteResource()">{{locale.LABEL_OK}}</button>
  </wms-dialog-footer>
</wms-dialog>
